// src/constants/colors.js

const Colors = {
  sidebar_blue: '#3969E7',
  bg_blue: '#3969E7',
  bg_green: '#0cba91',
  bg_dark_pink: '#ff6c6c',
  bg_yellow: '#fbbd4a',
  bg_orange: '#e89464',
  bg_gray: '#b0bac9',
  bg_success: '#0cba91',
  bg_damage: '#ff6c6c',
  bg_semi_damage: '#fbbd4a',
  bg_not_found: '#e89464',
  background: '#ffffff',
  text: '#212529',
  exportbBtn:'#adb5bd',
  sec_button_border_color: '#3969E7',
  grey:'#ddd',
  themeBgColor:'#3969E7',
  lightBlue:'#E7F0FB',
  lightBlueBorder:'#90caf9',
  lightGreen:'#E7F0FB',

  background_color:'#DFE7FB',


  // order status Color
  rnet_light_yellow:'#fff6CD',
  rnet_dark_yellow:'#9A6800',
  rnet_light_blue:'#C9DEF4',
  rnet_dark_blue:'#0C437F',
  rnet_light_red:'#F4C9C9',
  rnet_dark_red:'#843333',
  rnet_light_red_pastel:'#FCE8E6',
  rnet_dark_red_pastel:'#B71C1C',
  rnet_light_plural:'#F2EBFF',
  rnet_dark_plural:'#A677FD',
  rnet_light_green_pastel:'#CBF4C9',
  rnet_dark_green_pastel:'#64B161',
};

export default Colors;



// padding:'5px 10px',
// fontSize:'13px'
